import React from "react";
import useGetListOptionHook from "../../Devices/hooks/useGetListOptionHook";
import { ListOption } from "../../Devices/data/ListOption";
import useGetUserAssignmentsHook from "../hooks/useGetUserAssignmentsHook";
import { UserAssignment } from "../interfaces/UserAssignment";

type DevicesContextProps = {
    listOptions: ListOption[];
    isListOptionFetching: boolean;
    refetchListOption: () => void;
    userAssignments: UserAssignment[];
    isUserAssignmentFetching: boolean;
    refetchUserAssignment: () => void;
};

const UserAssignmentContext = React.createContext<DevicesContextProps>(null!);

export function UserAssignmentsProvider({ children }: { children: React.ReactNode }) {
    const { listOptions, isListOptionFetching, refetchListOption } = useGetListOptionHook();
    const  { userAssignments, isUserAssignmentFetching, refetchUserAssignment } = useGetUserAssignmentsHook();

    return (
        <UserAssignmentContext.Provider value={{
            listOptions, isListOptionFetching, refetchListOption,
            userAssignments, isUserAssignmentFetching, refetchUserAssignment
        }}>
            {children}
        </UserAssignmentContext.Provider>
    );
}

export function useUserAssignmentsContext() {
    return React.useContext(UserAssignmentContext);
}